import { graphql } from 'gql'

export const SIGN_IN = graphql(`
  mutation signIn($email: String!, $password: String!, $canAccessGamConnection: Boolean!) {
    signIn(input: { email: $email, password: $password }) {
      accessToken
      refreshToken

      user {
        ...AuthUserFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`)
